module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-six3.bc116aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-six3.png
// module id = T1DL
// module chunks = 0